import * as types from '../mutation-types'

export default {
  state: {
    pending: false,
    errorCode: null
  },
  mutations: {
    [types.VIEW_PENDING_START] (state) {
      state.pending = true
    },
    [types.VIEW_PENDING_DONE] (state) {
      state.pending = false
    },
    [types.VIEW_ERROR_CODE_SET] (state, code) {
      state.errorCode = code
    },
    [types.VIEW_STATE_INIT] (state) {
      state.pending = false
      state.errorCode = null
    }
  },
  actions: {
    startPending ({ commit }) {
      commit(types.VIEW_PENDING_START)
    },
    donePending ({ commit }) {
      commit(types.VIEW_PENDING_DONE)
    },
    setError ({ commit }, err) {
      if (err.code) {
        commit(types.VIEW_ERROR_CODE_SET, err.code)
      } else {
        commit(types.VIEW_ERROR_CODE_SET, 'unknown')
        throw err
      }
    },
    initViewState ({ commit }) {
      commit(types.VIEW_STATE_INIT)
    }
  },
  getters: {
    viewPending: (state) => state.pending,
    viewErrorCode: (state) => state.errorCode
  }
}
